interface PageView {
  page_title: string
  page_location: string
}

interface SwapEvent {
  type: 'swap' | 'conversion'
  from_token: string
  to_token: string
  amount: number
  amount_received: number
}

interface StakeEvent {
  direction: 'stake' | 'unstake'
  amount: number
}

interface SendTokenEvent {
  token: string
  amount: number
}

interface SendNFTEvent {
  nft: string
}

interface MintEvent {
  token: string
  amount: number
}

interface CycleTopupEvent {
  amount: number
}

interface CustomTokenAddedEvent {
  standard: string
  address: string
  name: string
}

export interface GAUserContext {
  registered: boolean
  region: string
  locale: string
  language: string
  platform: 'ios' | 'android' | 'extension'
  version: string
}

export type GAEvent =
  | PageView
  | SwapEvent
  | StakeEvent
  | SendTokenEvent
  | SendNFTEvent
  | MintEvent
  | CycleTopupEvent
  | CustomTokenAddedEvent

export enum GAEventName {
  PAGE_VIEW = 'page_view',
  SWAP = 'swap',
  STAKE = 'stake',
  SEND_TOKEN = 'send_token',
  SEND_NFT = 'send_nft',
  MINT = 'mint',
  CYCLE_MINT = 'cycle_mint',
  CYCLE_TOPUP = 'topup',
  DEPOSIT_ODIN = 'deposit_odin',
  WITHDRAW_ODIN = 'withdraw_odin',
  CUSTOM_TOKEN_ADDED = 'custom_token_added',
  BRIDGE_ONESEC = 'bridge_onesec',
}
